<template>
    <contentCardIndex >
        <template slot="cardContent">
                <v-row align="center">
                    <v-col cols="12" md="3" lg="3" class="mx-0 px-0">
                        
                        <alternativeTextField2
                            @onChanged="(v) => {trySearch(v);}" 
                            :valueInput="tableProps.search"
                            :rule="[]"
                            :placeholder="'Buscar'"
                            :label="''"
                            
                            :prependInnerIcon="'mdi-magnify'"
                            class="pick-3"
                            data-cy="search-input"
                        ></alternativeTextField2>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col   cols="12" md="3" lg="3" xl="2" class="mx-0 ">
                        <v-row justify="end">
                            <primaryButton data-cy="create-btn" :props="createBtnData"></primaryButton>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="mt-md-0">
                    <v-col class="mx-0 px-0">
                        <datatable data-cy="index-table" :props="tableProps" @methodHandler="method_handler">
                        
                        </datatable>
                    </v-col>
                </v-row>
                <modal data-cy="index-modal" :props="modalProps" @modalResponse="method_handler">
                    <!-- Buttons -->
                    <template slot="cardActions">
                        <v-row justify="end" data-cy="index-modal-actions">
                            <v-col cols="12" sm="4">
                                <secondaryButton
                                data-cy="cancel-modal-btn"
                                :props="cancelModal"
                                ></secondaryButton>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <primaryButton
                                data-cy="accept-modal-btn"
                                :props="acceptModal"
                                ></primaryButton>
                            </v-col>
                        </v-row>
                    </template> 
                </modal>
                
                <!-- RESET PASSWORD -->
                <modal data-cy="index-password-modal" :props="modalPasswordProps" @modalResponse="method_handler">
                    <!-- FORM -->
                    <template slot="cardBody">
                        <v-form ref="form" @submit.prevent="save">
                            <v-row>
                                <v-col class="py-2">
                                    <textFieldForm 
                                        @valueChange="(v) => {password = v; delete serverErrors.password}" 
                                        :valueInput="password" 
                                        :rule="[...rules.required, ...rules.length8]" 
                                        label="Contraseña"
                                        :errorMessages="serverErrors.password"
                                        :count="true"
                                        :prependInnerIcon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="showPass ? 'text' : 'password'"
                                        @clickAppend="() => {showPass = !showPass}"
                                        data-cy="password-input"
                                    ></textFieldForm>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-2">
                                    <textFieldForm 
                                        @valueChange="(v) => {password_confirmation = v; delete serverErrors.password_confirmation}" 
                                        :valueInput="password_confirmation" 
                                        :rule="[...rules.required, ...rules.samePassword, ...rules.length8]" 
                                        label="Confirmar contraseña"
                                        :errorMessages="serverErrors.password_confirmation"
                                        :count="true"
                                        :type="showPass ? 'text' : 'password'"
                                        @click:append="showPass = !showPass"
                                        data-cy="password_confirmation-input"
                                    ></textFieldForm>
                                </v-col>
                            </v-row>
                        </v-form>
                    </template>
                    <!-- Buttons -->
                    <template slot="cardActions">
                        <v-row justify="end" data-cy="index-password-modal-actions">
                            <v-col cols="12" sm="4">
                                <secondaryButton
                                data-cy="cancel-password-modal-btn"
                                :props="cancelPasswordModal"
                                ></secondaryButton>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <primaryButton
                                data-cy="accept-password-modal-btn"
                                :props="acceptPasswordModal"
                                ></primaryButton>
                            </v-col>
                        </v-row>
                    </template> 
                </modal>
        </template>

        
    
    </contentCardIndex>

        
</template>
<script>
import Utils from '../../../helpers/Utils'
export default {
    data(){
		return {
           
            password: '',
            password_confirmation: '',
            showPass: false,
            serverErrors:{},
			search: '',
            selectedID: '',
			actions: [
				
				{
					name: 'Editar',
					icon: {
						color: 'primary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'banks.edit',
                    dataCy: "edit-link"
				},
                {
					name: 'Restablecer contraseña',
					icon: {
						color: 'primary',
						icon: 'mdi-restore'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'changePasswordModal',
                    // permissions: 'banks.delete',
                    dataCy: "password-link"
				},
               
				{
					name: 'Borrar',
					icon: {
						color: 'primary',
						icon: 'mdi-delete-outline',
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteItemModal',
                    permissions: 'banks.delete',
                    dataCy: "delete-link"
				},
			],
			tableProps: {
				headers: [
                    {
						text: 'Nombre',
						align: 'left break-words',
						value: 'employee_name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Email',
						align: 'center break-words',
						value: 'email',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Estatus',
						align: 'center break-words',
						value: 'status',
						class: 'table-b-border black--text'
					},
                   
					
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '10%',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: '',
				loading: false
			},
			
			
            createBtnData: {
                text: "Nuevo Usuario",
                icon: "mdi-plus",
				to: "UsersCreate",
				block: false,
                click: ()=>{}
            },

			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelModal: {
                text: "No, cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                cy:"cancel-modal-btn",
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
                textColorLevel: '0',
				loading:false,
                cy:"accept-modal-btn",
                click: ()=>{this.delete()}
            },

            modalPasswordProps:{
                visible: false,
				width: '500',
				title: 'Actualizar contraseña',
				text: '',
				loading: false,
				bottomLineColor: '',
                persistent:true,
            },

            cancelPasswordModal: {
                text: "Cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalPasswordProps.visible = false; this.resetPassForm()}
            },
            acceptPasswordModal: {
                text: "Aceptar",
                icon: "",
				to: "",
				block: true,
				loading:false,
                click: ()=>{this.changePassword()}
            },

            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
                samePassword:[
                    (v) => v == this.password || "Las contraseñas no coinciden",
                ],
                length8:[
                    v => !!v || 'El campo requerido',
                    v => (!!v && v.length >= 8) || 'Al menos de 8 caracteres'
                ]
				
				
            },
		}
	},

	mounted(){
		this.index();
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
	},

    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},
        validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        onResize () {
            
            if(window.innerWidth < 960){
                this.createBtnData.block = true;
                
            }
            else{
                this.createBtnData.block = false;
                
            }
        },
      
        trySearch(val){
            this.tableProps.search = val;
        },
		index() {
			this.tableProps.loading = true;
           
			// call api
			this.$api.user.list()
				.then((resp) =>{
					//console.log(resp);
					this.tableProps.items = resp.data.reverse().map((x,i) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions))
                       
						
                        x.actions[0].action = { name: 'UsersEdit', params: { id: x.id } }
						

						x['parameters'] = { id: x.id, name: x.employee?.name??"", index: i};

                        x.employee_name = x.employee?.name??"";
                        x.email = x.email??"";
                        x.status = x.status == "Active" ? "Activo" : "Inactivo";
                       
						return x;
					});
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},



		deleteItemModal(parameters)
		{
			//console.log(parameters);
			this.selectedID = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: `¿Estás seguro de eliminar "${parameters.name}"?`,
				
			}
            console.log(this.selectedID)
			this.modalProps.visible = true;
			
		},


		delete()
		{
			//console.log(this.selectedID);
			this.acceptModal.loading = true;
			this.$api.user.delete(this.selectedID)
			// eslint-disable-next-line
			.then((response) => {
				
				this.$store.dispatch('snackbarSuccess', `Se ha eliminado`);
				this.index()
				// eslint-disable-next-line
			}).catch(error => {
				if(error.response.status === 422){
                    this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al eliminar'}`);
                }else{
                    this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
                }

				
			})
			.finally(() => {
				this.modalProps.visible = false;
				this.acceptModal.loading = false;
			})
		},

        resetPassForm()
        {
            this.password = this.password_confirmation = '';
            this.$refs.form.reset();
        },
        changePasswordModal(parameters)
        {
            this.selectedID = parameters.id;
			this.modalPasswordProps = {
				...this.modalPasswordProps,
			}
            console.log(this.selectedID)
			this.modalPasswordProps.visible = true;
        },

        changePassword()
        {   
            if(this.validate())
            {
                this.modalPasswordProps.loading = true;
                this.$api.user.changePassword(this.selectedID, {user: {'password':this.password}})
                    .then(() => {
                        this.$store.dispatch('snackbarSuccess', `Se ha cambiado la contraseña`);
                        this.resetPassForm();
                        this.modalPasswordProps.visible = false;
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                            break;
                           
                        }
                    })
                    .finally(() => {
                        this.modalPasswordProps.loading = false;
                        
                    })
                ;
            }
        },


    }
}
</script>